import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import MaterialComponent from "./MaterialComponent";
import Spinner from "../../sample/spinner";
import { Link } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import "../../../css/course-catelog.css";
import Chip from "@material-ui/core/Chip";
import Latex from "./Latex";

class HandsonAssesment extends Component {
  constructor(props) {
    super(props);
    const handsonAsslist = [];
    const savehandsonAsslist = [];
    this.state = {
      contentType: props.contentType,
      contentId: props.contentId,
      handsonAsslist,
      savehandsonAsslist,
      modalIsOpen: false,
      secondModalIsOpen: false,
      thirdModalIsOpen: false,
      answertext: "",
      isLoading: false,
      selectedAnsFile: null,
      issavedata: false,
      loading: false,
      showComponent: false,
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openSecondModal = this.openSecondModal.bind(this);
    this.closeSecondModal = this.closeSecondModal.bind(this);
    this.openthirdModal = this.openthirdModal.bind(this);
    this.closethirdModal = this.closethirdModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
   
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.contentType !== this.props.contentType ||
      prevProps.contentId !== this.props.contentId
    ) {
      this.setState({
        contentType: this.props.contentType,
        contentId: this.props.contentId,
      });

      if (this.props.contentType === "Topiclevel") {
        this.getHandsondata();
      } else {
        // this.getUnitMcq();
      }
    }
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  openSecondModal() {
    this.setState({
      secondModalIsOpen: true,
    });
  }

  closeSecondModal() {
    this.setState({ secondModalIsOpen: false });
  }

  openthirdModal() {
    this.setState({
      thirdModalIsOpen: true,
    });
  }

  closethirdModal() {
    this.setState({ thirdModalIsOpen: false });
  }

  componentDidMount() {
    this.getHandsondata();
  }
  async getHandsondata() {
    this.setState({ showComponent: true });
    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));
    formData.append("topic", this.props.contentId);
    // formData.append("topic", this.props.contentId);
    axios
      .post("LearnerAssignment/gethandsonAssignment", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          this.setState({
            handsonAsslist: res.data.handsonAsslist,
            issavedata: false,
            showComponent: false,
          });

          return res;
        }
        throw res;
      })
      .catch((error) => {
        toast.error("Please try again!!", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }
 

  sleep(milliseconds) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }

  handleSubmit(e, assoffid , subans) {
    e.preventDefault();
    this.savehandson(assoffid ,subans );
  }

  async savehandson(assoffid , subans) {
    //this.setState({ isLoading: true });
    this.setState({ loading: true });
    if (this.state.selectedAnsFile) {
      let filename = this.state.selectedAnsFile.name.split(".").pop();
      if (
        filename !== "pdf" &&
        filename !== "jpg" &&
        filename !== "xls" &&
        filename !== "jpeg" &&
        filename !== "xlsx" &&
        filename !== "docx" &&
        filename !== "doc" &&
        filename !== "txt"
      ) {
      //  console.log("upload only" + filename);
        toast.error(" upload only pdf/jpg/jpeg/docx/txt/xlsx files");
        await this.sleep(3000);
        this.setState({ loading: false });
        return;
      }
    }
   
    if((this.state.answertext ==""  || this.state.answertext ==null ) &&  subans  =="" ){
      toast.error("Enter Answer");
            await this.sleep(3000);
            this.setState({ loading: false });
            return;
    }else{
    var formData = new FormData();
if(this.state.answertext !=""){
  formData.append("desc", this.state.answertext);
}else{
  formData.append("desc",subans);
}
    
    formData.append("assfile", this.state.selectedAnsFile);
    formData.append("assoff", assoffid);

    axios
      .post("LearnerAssignment/saveHandsonAssignment", formData)

      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          this.setState({
            loading: false,
            handsonAsslist: res.data.savehandsonAsslist,
            issavedata: true,
          });
          toast.success(res.data.msg);
        } else {
          toast.error("Something went wrong");
        }
      }).catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
    }
  }

  render() {
    return (
      <div>
        {this.state.showComponent === true ? (
          <>
            <Spinner />
          </>
        ) : (
          ""
        )}
        <div class="row">
          <div className="col-lg-6">
            <Chip
              label="Hands On"
              variant="outlined"
              className="ft-size"
              color="primary"
            />
          </div>
        </div>
        <br />
        <div id="style-6" class="scrollmcq">
        {this.state.handsonAsslist.map((item, indexitem) => (
          <>
            <div class="card p-3 mb-2">
              <div class="row">
                <div class="col-md-9 col-lg-9 text-left">
                {item.srno} ) &nbsp;
                  <label for={item.assignmenttext}>
                  <Latex> <span
                      dangerouslySetInnerHTML={{
                        __html: item.assignmenttext,
                      }}
                    /></Latex>
                  </label>
                </div>
                <div class="col-lg-3 col-md-3 text-right">
                  {item.weightage === null || item.weightage === 0 ? (
                    <>
                    <Chip
                      label="Non Graded "
                      className="ft-size"
                    />
                    </>
                  ) : (
                    <>
                  <Chip
                    label={"weightage :"+ item.weightage}
                    className="ft-size"
                  />
                    </>
                  )}
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <label>
                    <b>Test Case :</b>
                  </label>

                  <textarea
                    class="form-control"
                    name="testcase"
                    id="testcase"
                    value={item.testcases}
                    readOnly
                    rows={5}
                    cols={120}
                  ></textarea>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-sm-12">
                  <label>
                    <b>Expected output :</b>
                  </label>
                  
                  <textarea
                    class="form-control"
                    name="expoutput"
                    id="expoutput"
                    value={item.expectedoutput}
                    readOnly
                    rows={5}
                    cols={120}
                  ></textarea>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-sm-12">
                  {item.assignmentpath !== null ? (
                    <>
                      <Link onClick={this.openModal}>
                        <FontAwesomeIcon icon={faDownload} /> &nbsp;&nbsp;
                        Downloadable Attachment{" "}
                      </Link>
                      <Modal
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={this.closeModal}
                        size="lg"
                        style={{
                          top: "0%",
                          left: "0%",
                          right: "0%",
                          bottom: "0%",
                          maxWidth: "1600px",
                          width: "60%",
                          height: "60%",
                        }}
                      >
                        <ModalHeader toggle={this.closeModal}></ModalHeader>
                        <ModalBody>
                          <div>
                            <MaterialComponent
                              contentType="contenttype"
                              contentId="0"
                              materialid="0"
                              materialtype={item.assignmentpath
                                .split(".")
                                .pop()}
                              materialpath={item.assignmentpath}
                            />
                          </div>
                        </ModalBody>
                        <ModalFooter></ModalFooter>
                      </Modal>
                      <br />
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>{" "}
              <div class="row">
                <div class="col-sm-12">
                  {item.expectedoutputfilepath !== null ? (
                    <>
                      <Link onClick={this.openthirdModal}>
                        <FontAwesomeIcon icon={faDownload} /> &nbsp;&nbsp;
                        Expected output{" "}
                      </Link>
                      <Modal
                        isOpen={this.state.thirdModalIsOpen}
                        onRequestClose={this.closethirdModal}
                        size="lg"
                        style={{
                          top: "0%",
                          left: "0%",
                          right: "0%",
                          bottom: "0%",
                          maxWidth: "1600px",
                          width: "60%",
                          height: "60%",
                        }}
                      >
                        <ModalHeader
                          toggle={this.closethirdModal}
                        ></ModalHeader>
                        <ModalBody>
                          <div>
                            <MaterialComponent
                              contentType="contenttype"
                              contentId="0"
                              materialid="0"
                              materialtype={item.expectedoutputfilepath
                                .split(".")
                                .pop()}
                              materialpath={item.expectedoutputfilepath}
                            />
                          </div>
                        </ModalBody>
                        <ModalFooter></ModalFooter>
                      </Modal>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>{" "}
              <div class="row">
                <div class="col-sm-12">
                  <label>{item.answertext}</label>

                  <textarea
                    class="form-control"
                    name="answertext"
                    placeholder="Answer Text"
                    id="answertext"
                    defaultValue={item.answertext}
                    onChange={(e) => this.setState({ answertext: e.target.value })}
                    
                    rows={5}
                    cols={120}
                    required=""
                  ></textarea>
                </div>
              </div>
              <br />
              <div class="row ">
                <div class="col-sm-6">
                  <input
                    class="form-control"
                    id="selectedAnsFile"
                    type="file"
                    name="selectedAnsFile"
                    onChange={(e) =>
                      this.setState({
                        selectedAnsFile: e.target.files[0],
                      })
                    }
                  />
                </div>
                <div class="col-sm-6 text-right pt-1">
                    {item.answerfilepath !== null ? (
                      <>
                        <Link onClick={this.openSecondModal}>
                          <FontAwesomeIcon icon={faDownload} /> &nbsp;&nbsp;
                          View Last Submitted Assignment{" "}
                        </Link>
                        <Modal
                          isOpen={this.state.secondModalIsOpen}
                          onRequestClose={this.closeSecondModal}
                          size="lg"
                          style={{
                            top: "0%",
                            left: "0%",
                            right: "0%",
                            bottom: "0%",
                            maxWidth: "1600px",
                            width: "60%",
                            height: "60%",
                          }}
                        >
                          <ModalHeader
                            toggle={this.closeSecondModal}
                          ></ModalHeader>
                          <ModalBody>
                            <div>
                              <MaterialComponent
                                contentType="contenttype"
                                contentId="0"
                                materialid="0"
                                materialtype={item.answerfilepath
                                  .split(".")
                                  .pop()}
                                materialpath={item.answerfilepath}
                              />
                            </div>
                          </ModalBody>
                          <ModalFooter></ModalFooter>
                        </Modal>
                      </>
                    ) : (
                      ""
                    )}
                </div>
              </div>
              <div class="row ">
                <div class="col-sm-12">
                  <p className="col-p">
                    ** The previous assignment file will be overwritten when you
                    submit a new file.
                  </p>
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-lg-12 text-center">
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={this.state.loading}
                    onClick={(e) =>
                      this.handleSubmit(e, item.assignmentOfferingid , item.answertext)
                    }
                  >
                    Submit
                  </Button>

                  {this.state.loading === true ? (
                    <CircularProgress
                      size={24}
                      color="green"
                      className="buttonProgress1"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {/* <div class="row">
                <div class="col-sm-12">
                  <center>
                    {item.answerfilepath !== null ? (
                      <>
                        <Link onClick={this.openSecondModal}>
                          <FontAwesomeIcon icon={faDownload} /> &nbsp;&nbsp;
                          View Last Submitted Assignment{" "}
                        </Link>
                        <Modal
                          isOpen={this.state.secondModalIsOpen}
                          onRequestClose={this.closeSecondModal}
                          size="lg"
                          style={{
                            top: "0%",
                            left: "0%",
                            right: "0%",
                            bottom: "0%",
                            maxWidth: "1600px",
                            width: "60%",
                            height: "60%",
                          }}
                        >
                          <ModalHeader
                            toggle={this.closeSecondModal}
                          ></ModalHeader>
                          <ModalBody>
                            <div>
                              <MaterialComponent
                                contentType="contenttype"
                                contentId="0"
                                materialid="0"
                                materialtype={item.answerfilepath
                                  .split(".")
                                  .pop()}
                                materialpath={item.answerfilepath}
                              />
                            </div>
                          </ModalBody>
                          <ModalFooter></ModalFooter>
                        </Modal>
                      </>
                    ) : (
                      ""
                    )}
                  </center>
                </div>
              </div> */}
            </div>
          </>
        ))}
      </div>
      </div>
    );
  }
}

export default HandsonAssesment;
